import links from "@/links/links";

export default {
  actions: {
    FETCH(buildingId) {
      return this.get(links.VOTING_CATEGORY_FETCH(buildingId), {
        dataKey: "hydra:member",
      });
    },
  },
};
